import { Feature, FeatureName } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { CountryISO } from '@/types/places';

const ID_ISSUE_DATE_NOT_REQUIRED_COUNTRIES = [
  CountryISO.Barbados,
  CountryISO.StVincent,
];

export function getAllowedIdentityTypes(
  identityTypes: string[] | DocumentType[],
  features: Feature[],
) {
  let types = [...identityTypes];

  if (
    features.some(
      item => item.feature === FeatureName.NoIdentityID && item.enabled,
    )
  ) {
    types = types.filter(item => item !== DocumentType.Id);
  }

  return types;
}

export function requiresIdentityIssueDate(
  docType?: string | null,
  issueCountry?: CountryISO | null,
) {
  return !(
    docType === DocumentType.Id &&
    !!issueCountry &&
    ID_ISSUE_DATE_NOT_REQUIRED_COUNTRIES.includes(issueCountry)
  );
}

export function requiresIdentityExpiryDate(
  docType?: string | null,
  issueCountry?: CountryISO | null,
) {
  return !(
    (docType === DocumentType.Id && issueCountry === CountryISO.Guyana) ||
    (docType === DocumentType.Nis && issueCountry === CountryISO.Grenada) ||
    docType === DocumentType.CBBExtract
  );
}
